import { useParams } from "react-router-dom";

import { SessionRecordingPlayer } from "~/providers/components/patientProfile/sessions/SessionRecordingPlayer";
import { SessionTranscriptViewer } from "~/providers/components/patientProfile/sessions/SessionTranscriptViewer";
import {
  useGetPatientZoomMeeting,
  useGetPatientZoomMeetingRecording,
  useGetPatientZoomMeetingTranscript,
} from "~/providers/hooks/queries/useGetPatientZoomMeeting";

export const SessionTranscript = () => {
  const { patientId, sessionId } = useParams();
  const hasRouteParams = Boolean(patientId && sessionId);

  const { data: session } = useGetPatientZoomMeeting({
    patientId: patientId ?? "",
    sessionId: sessionId ?? "",
    enabled: hasRouteParams,
  });

  const { data: transcript, isLoading: isLoadingTranscript } =
    useGetPatientZoomMeetingTranscript({
      patientId: patientId ?? "",
      sessionId: sessionId ?? "",
      transcriptStatus: session?.transcript_status,
      enabled: hasRouteParams && !!session,
    });

  const { data: recording, isLoading: isLoadingRecording } =
    useGetPatientZoomMeetingRecording({
      patientId: patientId ?? "",
      sessionId: sessionId ?? "",
      recordingStatus: session?.recording_status,
      enabled: hasRouteParams && !!session,
    });

  if (!session) return null;

  return (
    <div className="flex flex-col gap-4">
      <SessionRecordingPlayer
        recordingStatus={session.recording_status}
        presignedUrl={recording?.presigned_url}
        isLoadingRecording={isLoadingRecording}
      />
      <SessionTranscriptViewer
        transcriptStatus={session.transcript_status}
        presignedUrl={transcript?.presigned_url}
        isLoadingTranscript={isLoadingTranscript}
      />
    </div>
  );
};
